import { IconsProps } from '@/types/shared'
import React from 'react'

const ApprovedIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
            >
                <path
                    d="M11.157 18.85L7.60703 15.3L9.05703 13.85L11.157 15.95L15.357 11.75L16.807 13.2L11.157 18.85ZM5.20703 22.5C4.65703 22.5 4.1862 22.3042 3.79453 21.9125C3.40286 21.5208 3.20703 21.05 3.20703 20.5V6.5C3.20703 5.95 3.40286 5.47917 3.79453 5.0875C4.1862 4.69583 4.65703 4.5 5.20703 4.5H6.20703V2.5H8.20703V4.5H16.207V2.5H18.207V4.5H19.207C19.757 4.5 20.2279 4.69583 20.6195 5.0875C21.0112 5.47917 21.207 5.95 21.207 6.5V20.5C21.207 21.05 21.0112 21.5208 20.6195 21.9125C20.2279 22.3042 19.757 22.5 19.207 22.5H5.20703ZM5.20703 20.5H19.207V10.5H5.20703V20.5ZM5.20703 8.5H19.207V6.5H5.20703V8.5Z"
                    fill={props?.color || '#66BB6A'}
                />
            </svg>
        </div>
    )
}

export default ApprovedIcons
